// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__oSRg_","title":"ClientInsurance_title__OvtEK","itemText":"ClientInsurance_itemText__Ypyuw"};